(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.filter('RfGlobalShortDateFilter', [RfGlobalShortDateFilterFn]);

    // short-date filter (dayname, day), uses moment.locale (set on login)
    function RfGlobalShortDateFilterFn() {
        return function (date) {
            if (date) {
                var dateMoment = moment(date);
                return dateMoment.format('dd DD MMM Y');
            }
            return date;
        };
    }
})();